import { render, staticRenderFns } from "./PropertyAnswerSyncBackModal.vue?vue&type=template&id=49a36b12&"
import script from "./PropertyAnswerSyncBackModal.vue?vue&type=script&lang=js&"
export * from "./PropertyAnswerSyncBackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Template: require('/lasso/components/templates/Template.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a36b12')) {
      api.createRecord('49a36b12', component.options)
    } else {
      api.reload('49a36b12', component.options)
    }
    module.hot.accept("./PropertyAnswerSyncBackModal.vue?vue&type=template&id=49a36b12&", function () {
      api.rerender('49a36b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/properties/PropertyAnswerSyncBackModal.vue"
export default component.exports